import { Confidence } from "@/data/directoryTypes";

interface ConfidenceBadgeProps {
  confidence: Confidence;
}

const ConfidenceBadge = ({ confidence }: ConfidenceBadgeProps) => {
  const styles: Record<Confidence, string> = {
    High: "bg-foreground/10 text-foreground border-foreground/20",
    Med: "bg-primary/10 text-primary border-primary/20",
    Low: "bg-muted text-muted-foreground border-border",
  };

  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-mono font-medium border ${styles[confidence]}`}>
      {confidence}
    </span>
  );
};

export default ConfidenceBadge;
